import React, { FC } from 'react'
import styles from '../style.module.css'

const InvalidUidScreen: FC = () => {
  return (
    <div className={styles.invalidUidScreen}>
      {/* TODO: design.md 確定後にコピー・デザインを更新 */}
      <p className={styles.invalidUidMessage}>URLが無効です</p>
    </div>
  )
}

export default InvalidUidScreen
